import React from 'react';
import { Link } from 'react-router-dom';
import BackButton from '@/components/BackButton';

const FAQ: React.FC = () => {
  return (
    <div className="min-h-screen bg-background py-12">
      <BackButton />
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto prose prose-slate dark:prose-invert">
          <h1>Frequently Asked Questions</h1>

          <h2>General Questions</h2>
          
          <h3><strong>What is NEXUS Phish?</strong></h3>
          <p>
            NEXUS Phish is an educational platform designed for cybersecurity professionals and researchers 
            to conduct authorized phishing awareness training and security testing.
          </p>

          <h3><strong>Is this tool legal to use?</strong></h3>
          <p>
            NEXUS Phish is legal when used for authorized security testing and educational purposes. 
            Users must obtain proper authorization and comply with all applicable laws and regulations.
          </p>

          <h2>Technical Questions</h2>

          <h3><strong>How do I set up Telegram notifications?</strong></h3>
          <p>
            Follow these steps:
          </p>
          <ol>
            <li>Create a Telegram bot using @BotFather</li>
            <li>Copy the provided API token</li>
            <li>Configure the token in platform settings</li>
            <li>Test the connection using the verification tool</li>
          </ol>

          <h3><strong>Can I customize the templates?</strong></h3>
          <p>
            Yes, all templates can be customized to match specific testing scenarios while maintaining 
            core functionality.
          </p>

          <h2>Security & Privacy</h2>

          <h3><strong>How is collected data handled?</strong></h3>
          <p>
            All data is handled according to strict security protocols. Data is:
          </p>
          <ul>
            <li>Encrypted during transmission</li>
            <li>Stored securely</li>
            <li>Automatically deleted after specified periods</li>
            <li>Never shared with third parties</li>
          </ul>

          <h3><strong>What security measures are in place?</strong></h3>
          <p>
            We implement multiple security layers including:
          </p>
          <ul>
            <li>End-to-end encryption</li>
            <li>Secure authentication</li>
            <li>Regular security audits</li>
            <li>Compliance with security standards</li>
          </ul>

          <div className="not-prose mt-8 border-t pt-8">
            <p className="text-sm text-muted-foreground">
              Still have questions? <Link to="/contact" className="text-primary hover:underline">Contact our support team</Link>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;